import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Copy } from "lucide-react";
import { toast } from "sonner";

// v23-B B2: het tijdelijke wachtwoord blijft staan tot je het venster sluit.
export function TijdelijkWachtwoordDialog({ info, onClose }) {
  const kopieer = async () => {
    try { await navigator.clipboard.writeText(info.wachtwoord); toast.success("Gekopieerd"); }
    catch { toast.error("Kopiëren lukte niet; selecteer het wachtwoord en kopieer het zelf."); }
  };
  return (
    <Dialog open={!!info} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="tijdelijk-wachtwoord-dialog" className="sm:max-w-md max-w-[calc(100vw-1.5rem)]">
        <DialogHeader className="min-w-0">
          <DialogTitle className="break-words">Tijdelijk wachtwoord{info ? ` voor ${info.username}` : ""}</DialogTitle>
          <DialogDescription>Geef dit wachtwoord door. Bij de eerste keer inloggen kies je zelf een nieuw.</DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 min-w-0">
          <input readOnly value={info?.wachtwoord || ""} data-testid="tijdelijk-wachtwoord-waarde" onFocus={(e) => e.target.select()}
            className="flex-1 w-0 min-w-0 font-mono text-base px-3 py-2 rounded-md border border-zinc-300 bg-zinc-50 text-zinc-900" />
          <button type="button" data-testid="tijdelijk-wachtwoord-kopieer" onClick={kopieer}
            className="min-h-[44px] inline-flex items-center gap-1.5 px-3 rounded-md border border-zinc-300 text-sm font-semibold text-zinc-800 hover:border-zinc-500 transition-colors">
            <Copy className="h-4 w-4" /> Kopieer
          </button>
        </div>
        <DialogFooter>
          <button type="button" data-testid="tijdelijk-wachtwoord-sluiten" onClick={onClose}
            className="min-h-[44px] px-4 rounded-md bg-zinc-900 text-white text-sm font-semibold hover:bg-zinc-700 transition-colors">Sluiten</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
